import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { PRODUCTS, COMPANY } from '../../siteData';
import {
  Section,
  SectionInner,
  SectionHeader,
  Eyebrow,
  SectionTitle,
  SectionLead,
} from '../ui/Section';
import {
  ProductsGrid,
  ProductCard,
  ProductTop,
  ProductMark,
  ProductName,
  ProductP,
  ProductOwnership,
  ProductLink,
} from './ProductsElements';

const Products = () => {
  return (
    <Section id='products' tone='subtle'>
      <SectionInner>
        <SectionHeader>
          <Eyebrow>Products</Eyebrow>
          <SectionTitle>Built and operated by us</SectionTitle>
          <SectionLead>
            Beyond client work, {COMPANY.legalName} builds and operates its own
            software products. Here is what we are shipping today.
          </SectionLead>
        </SectionHeader>
        <ProductsGrid>
          {PRODUCTS.map((product) => (
            <ProductCard key={product.name}>
              <ProductTop>
                <ProductMark>{product.name.charAt(0)}</ProductMark>
                <ProductName>{product.name}</ProductName>
              </ProductTop>
              <ProductP>{product.blurb}</ProductP>
              <ProductOwnership>{product.ownership}</ProductOwnership>
              <ProductLink
                href={product.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                Visit {product.name} <FiArrowUpRight />
              </ProductLink>
            </ProductCard>
          ))}
        </ProductsGrid>
      </SectionInner>
    </Section>
  );
};

export default Products;
